<!-- @todo All the settings panels should be combined into a single component -->
<template>
  <div>
    <TransitionRoot as="template" :show="!!props.open">
      <Dialog as="div" class="relative z-10" @close="close">
        <div class="fixed inset-0" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div
              class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full sm:pl-10"
            >
              <TransitionChild
                as="template"
                enter="transform transition ease-in-out duration-200"
                enter-from="translate-x-full"
                enter-to="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leave-from="translate-x-0"
                leave-to="translate-x-full"
              >
                <DialogPanel class="pointer-events-auto w-screen max-w-md">
                  <div
                    id="scroll-container"
                    class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                  >
                    <div class="fixed bg-white max-w-md w-full">
                      <div class="p-4 sm:p-6 border-b border-b-gray-200">
                        <div class="flex items-center justify-between">
                          <div class="flex sm:hidden">
                            <h1
                              v-if="!props.category"
                              class="font-semibold text-xl"
                            >
                              {{ t("admin.settings.categories.add_category") }}
                            </h1>
                            <h1 v-else class="font-semibold text-xl">
                              {{
                                t("admin.settings.categories.update_category")
                              }}
                            </h1>
                          </div>
                          <div v-if="!props.category">
                            <primary-button
                              class="hidden sm:flex"
                              :label="
                                t('admin.settings.categories.add_category')
                              "
                              @click="handleAddCategory"
                            />
                          </div>
                          <div v-else class="flex space-x-2 hidden sm:flex">
                            <primary-button
                              :label="
                                t('admin.settings.categories.update_category')
                              "
                              @click="handleUpdateCategory"
                            />
                            <button
                              @click="handleDeleteCategory"
                              type="button"
                              class="rounded-md border border-red-600 bg-white px-2.5 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none sm:w-auto sm:text-sm disabled:opacity-50"
                            >
                              <TrashOne class="w-5 text-red-600" />
                            </button>
                          </div>
                          <div class="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              class="rounded-sm bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                              @click="close"
                            >
                              <span class="sr-only">Close panel</span>
                              <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex flex-col space-y-8 mt-24 sm:mt-28 flex-1 px-4 sm:px-6"
                    >
                      <div class="flex flex-col space-y-3">
                        <Errors />

                        <div>
                          <span class="font-medium">
                            {{
                              t("admin.settings.categories.category_icon.title")
                            }}
                          </span>
                          <p class="text-gray-500 text-sm font-medium">
                            {{
                              t(
                                "admin.settings.categories.category_icon.description"
                              )
                            }}
                          </p>
                        </div>
                        <div class="flex space-x-4 items-center">
                          <div
                            class="rounded-xs flex justify-center items-center align-middle h-14 w-14 bg-gray-50"
                            v-if="
                              currentSelection.icon && currentSelection.color
                            "
                          >
                            <span
                              class="material-symbols-outlined text-3xl"
                              :style="{ color: currentSelection.color }"
                              >{{ currentSelection.icon }}</span
                            >
                          </div>
                          <div>
                            <button
                              @click="isIconSelectorOpen = true"
                              class="rounded-md border border-gray-300 bg-white px-2.5 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none sm:w-auto sm:text-sm disabled:opacity-50"
                            >
                              {{
                                currentSelection.icon && currentSelection.color
                                  ? t(
                                      "admin.settings.categories.category_icon.edit"
                                    )
                                  : t(
                                      "admin.settings.categories.category_icon.select"
                                    )
                              }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <hr />

                      <div class="flex flex-col space-y-3">
                        <div>
                          <span class="font-medium">
                            {{ t("admin.settings.categories.name.title") }}
                          </span>
                          <p class="text-gray-500 text-sm font-medium">
                            {{
                              t("admin.settings.categories.name.description")
                            }}
                          </p>
                        </div>
                        <input
                          v-model="currentSelection.name"
                          type="text"
                          name="category"
                          id="category"
                          class="block w-full rounded-sm border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                          placeholder="e.g. Cleaning"
                        />
                      </div>

                      <hr />

                      <div
                        class="flex flex-col space-y-3 pb-4"
                        v-if="props.category"
                      >
                        <div>
                          <span class="font-medium">
                            {{
                              t("admin.settings.categories.translations.title")
                            }}
                          </span>
                        </div>
                        <div
                          class="flex flex-col space-y-2 bg-gray-50 px-6 py-4 rounded-xs"
                        >
                          <div v-for="(value, key) in translations" :key="key">
                            <div v-if="key !== locale">
                              <div class="flex items-center justify-between">
                                <span class="text-sm font-medium text-gray-600">
                                  {{ t(`validation.values.locale.${key}`) }}
                                </span>
                                <input
                                  class="text-ellipsis bg-transparent border-2 border-transparent text-sm font-semibold text-gray-900 focus:bg-white focus:border-gray-500 hover:border-gray-500 hover:bg-white focus:ring-0 rounded-sm"
                                  type="text"
                                  v-model="translations[key]"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-4 py-4 w-full">
                      <div v-if="!props.category">
                        <primary-button
                          class="sm:hidden flex w-full"
                          :label="t('admin.settings.categories.add_category')"
                          @click="handleAddCategory"
                        />
                      </div>
                      <div v-else class="flex flex-col space-y-2 sm:hidden">
                        <primary-button
                          class="w-full"
                          :label="
                            t('admin.settings.categories.update_category')
                          "
                          @click="handleUpdateCategory"
                        />
                        <button
                          @click="handleDeleteCategory"
                          type="button"
                          class="rounded-md border border-red-600 text-red-600 bg-white px-2.5 py-2 text-base font-medium shadow-sm hover:text-gray-500 focus:outline-none sm:w-auto sm:text-sm disabled:opacity-50"
                        >
                          {{ t("components.buttons.delete") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <icon-selector
      :open="isIconSelectorOpen"
      :default-color="defaultColor"
      @close="isIconSelectorOpen = false"
      @icon-selected="handleIconSelected"
    />
  </div>
</template>

<script setup>
import { defineEmits, defineProps, reactive, ref } from "vue";
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton";
import IconSelector from "@/Tailwind/Components/Settings/Categories/IconSelector";
import { usePage } from "@inertiajs/vue3";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useI18n } from "vue-i18n";
import TrashOne from "@/Tailwind/Icon/TrashOne";
import Errors from "@/Tailwind/Components/Errors.vue";

const { t } = useI18n();

const tenant = usePage().props.tenant;
const locale = usePage().props.locale;
const defaultColor = usePage().props.defaultColor;

const emit = defineEmits(["close"]);
const props = defineProps({
  open: Boolean,
  category: Object,
});

const translations = reactive({
  en: props.category?.name_english,
  nl: props.category?.name_dutch,
  fr: props.category?.name_french,
  de: props.category?.name_german,
  es: props.category?.name_spanish,
  bg: props.category?.name_bulgarian,
  zh: props.category?.name_chinese,
  cs: props.category?.name_czech,
  da: props.category?.name_danish,
  et: props.category?.name_estonian,
  fi: props.category?.name_finnish,
  el: props.category?.name_greek,
  hu: props.category?.name_hungarian,
  id: props.category?.name_indonesian,
  it: props.category?.name_italian,
  ja: props.category?.name_japanese,
  lv: props.category?.name_latvian,
  lt: props.category?.name_lithuanian,
  pl: props.category?.name_polish,
  ro: props.category?.name_romanian,
  ru: props.category?.name_russian,
  sk: props.category?.name_slovak,
  sl: props.category?.name_slovenian,
  sv: props.category?.name_swedish,
  tr: props.category?.name_turkish,
  pt: props.category?.name_portuguese,
});

const isIconSelectorOpen = ref(false);
const currentSelection = reactive({
  icon: props.category?.icon,
  color: props.category?.color,
  name: props.category ? translations[locale] : null,
});

const handleIconSelected = (icon, color) => {
  isIconSelectorOpen.value = false;
  currentSelection.icon = icon;
  currentSelection.color = color;
};

const handleAddCategory = () => {
  router.post(
    route("settings.categories.store", [tenant]),
    {
      icon: currentSelection.icon,
      color: currentSelection.color,
      name: {
        [locale]: currentSelection.name,
      },
    },
    {
      onSuccess: () => close(),
    }
  );
};

const handleUpdateCategory = () => {
  router.put(
    route("settings.categories.update", [tenant, props.category]),
    {
      icon: currentSelection.icon,
      color: currentSelection.color,
      name: {
        ...translations,
        [locale]: currentSelection.name,
      },
    },
    {
      onSuccess: () => close(),
    }
  );
};

const handleDeleteCategory = () => {
  router.delete(route("settings.categories.destroy", [tenant, props.category]));
};

const close = () => emit("close");
</script>
